import {WalletPlatform} from '@/enums/WalletPlatform'

export const SdkNotInitializedError = (wallet: WalletPlatform): Error => {
  const walletString: string = String(wallet).trim()

  const formattedWallet: string = walletString
    ? walletString.charAt(0).toUpperCase() + walletString.slice(1).toLowerCase()
    : 'WalletSDK'

  return new Error(`${formattedWallet} not initialized`)
}

export const UnimplementedWallet: Error = new Error('Unimplemented Wallet')

export const WalletNotConnected: Error = new Error('Wallet not connected')

export const InvocationDoesNotExists: Error = new Error(
  'Invocation does not exists'
)

export const BadInvocationRequest: Error = new Error('Bad Invocation Request')

export const RejectedByUser: Error = new Error('Rejected by the user')

const errorCodeOf = (error: unknown): unknown =>
  (error as {code?: unknown} | null)?.code

const errorMessageOf = (error: unknown): string =>
  String((error as {message?: unknown} | null)?.message ?? '')

const errorTypeOf = (error: unknown): unknown =>
  (error as {type?: unknown} | null)?.type

const errorDescriptionOf = (error: unknown): string =>
  String((error as {description?: unknown} | null)?.description ?? '')

export const isRejectedByUserError = (error: unknown): boolean => {
  if (error === RejectedByUser) return true

  const code = errorCodeOf(error)
  if (code === 4001 || code === 5000 || code === 5002) return true

  const type = errorTypeOf(error)
  if (type === 'CANCELED' || type === 'CONNECTION_DENIED') return true

  return /reject|denied|cancel/i.test(
    `${errorMessageOf(error)} ${errorDescriptionOf(error)}`
  )
}

export const isWrongWalletNetworkError = (error: unknown): boolean => {
  const code = errorCodeOf(error)

  return (
    code === 5001 ||
    code === 5100 ||
    /chain|network/i.test(errorMessageOf(error))
  )
}

export const isUnsupportedWalletNamespaceError = (error: unknown): boolean =>
  errorCodeOf(error) === 5104 || /namespace/i.test(errorMessageOf(error))
